import { PlusIcon } from "lucide-react"
import { useTranslation } from "react-i18next"

import { cn } from "@f2e/ui/lib/utils"

import { PermissionButton } from "@/components/Auth"
import { Permission, Workspace } from "@/types"

interface CustomizeAgentNewButtonProps {
  className?: string
  workspace: Workspace
  onNewBasic?: () => void
}

const CustomizeAgentNewButton = ({
  className,
  workspace,
  onNewBasic,
}: CustomizeAgentNewButtonProps) => {
  const { t } = useTranslation()

  const handleNewBasic = () => {
    onNewBasic?.()
  }

  return (
    <PermissionButton
      permission={Permission.WsUpdateResources}
      workspace={workspace}
      disabledTooltip={t("common.noPermission")}
      className={cn(className)}
      onClick={handleNewBasic}
    >
      <PlusIcon className="w-4 h-4" />
      {t("workspace.new")}
    </PermissionButton>
  )
}

export { CustomizeAgentNewButton }
export default CustomizeAgentNewButton
